import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Gift } from 'lucide-react';
const bonos = [{
  title: 'Bono 1 — Planificador Semanal Integrado',
  description: 'Plan semanal que combina Manual del 10, Sistema de Pases, Tiros Libres y Tiros y Velocidad en una sola rutina de 7 días. Hoja de seguimiento de cumplimiento de 4 semanas con cálculo automático de % y gráfico de progreso.',
  image: 'https://cdn.magicpatterns.com/uploads/m1bibjWXXZor2aTfXzWw5f/Screenshot_2026-06-18_at_11.36.02_PM.png'
}, {
  title: 'Bono 2 — Programa de Velocidad (Tomo Único, 4 Semanas)',
  description: 'Semana 1: Técnica de carrera (skipping, arrancadas explosivas). Semana 2: Aceleración 0-10m (arrancadas, sprint resistido, cambios de dirección en T). Semana 3: Velocidad máxima 20-30m (sprint completo, 5-10-5, sprint en rampa). Semana 4: Velocidad específica con pelota (conducción a velocidad, arrancada + definición, test cronometrado).',
  image: 'https://cdn.magicpatterns.com/uploads/3D8JHAF2h9J927BDC5XGLs/Screenshot_2026-06-18_at_11.36.11_PM.png'
}, {
  title: 'Bono 3 — Estrategia de las 5 Formaciones Más Usadas en el Fútbol Moderno',
  description: 'Formación 4-3-3, 4-2-3-1, 4-4-2, 3-5-2, 4-3-1-2 — cada una con estructura, fortalezas/debilidades, rol del enganche.',
  image: 'https://cdn.magicpatterns.com/uploads/b5HVzLLreRYZ18tL92EW3L/Screenshot_2026-06-18_at_11.36.33_PM.png'
}];
interface BonosProps {
  onImageClick: () => void;
}
export function Bonos({
  onImageClick
}: BonosProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-gray-50 py-16 md:py-24" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-2">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-3">
          Bonos Incluidos
        </motion.h2>

        <div className="space-y-6" data-id="element-4">
          {bonos.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="border border-emerald-200 rounded-xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-5">
              <div className="w-full h-48 md:h-64 bg-gray-100 border-b border-emerald-100 overflow-hidden" data-id="element-6">
                <img src={bono.image} alt={bono.title} className="w-full h-full object-cover cursor-pointer hover:scale-105 transition-transform duration-500" onClick={onImageClick} data-id="element-7" />
              </div>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between hover:bg-emerald-50 transition-colors" data-id="element-8">
                <div className="flex items-center gap-4 text-left" data-id="element-9">
                  <Gift className="w-6 h-6 text-emerald-600 flex-shrink-0" data-id="element-10" />
                  <span className="font-bold text-gray-900 text-lg" data-id="element-11">
                    {bono.title}
                  </span>
                </div>
                <ChevronDown className={`w-6 h-6 text-gray-500 transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-12" />
              </button>

              <AnimatePresence data-id="element-13">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-14">
                    <div className="px-6 py-5 bg-emerald-50/50 border-t border-emerald-100" data-id="element-15">
                      <p className="text-gray-700 leading-relaxed" data-id="element-16">
                        {bono.description}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}